require([
    'components/decorator',
    'lib/history',
    'lib/pubsub',
    //services for api
    'components/services/serviceUtil',
    'components/services/queries',

    //components
    'components/util/alertmessage',
    'components/util/graphutil',
    'components/util/locale',
    'components/util/financeTreeUtil',
    'components/util/clearbutton',

    'jquery',
    'components/handlers',
    'components/news',
    'components/overlay',
    'components/sectors',
    'components/table',
    'components/panel',
    'components/type-ahead',
    'components/forms',
    'components/date-picker',

    // CkEditor not used at the moment, enable when the backoffice needs it
    // 'components/editor',

    "components/decorators/ie9",
    "components/decorators/email",
    "components/decorators/clearbutton",
    "components/decorators/submit-get-on-change",
    "components/decorators/recent",
    // "components/decorators/housenrs",
    "components/decorators/auto-truncate-menu",
    "components/decorators/main-menu",
    "components/decorators/submit-reload",
    "components/decorators/compliance",
    "components/decorators/autosuggest",
    "components/decorators/datev-autosuggest",
    "components/decorators/datev-update-client",
   // "components/decorators/SiteCatalyst",
   // "components/decorators/gauge",
   // "components/decorators/index-history",
   // "components/decorators/miniloket",
    "components/decorators/filters",
    "components/decorators/pagination",
    "components/decorators/sorting",
    "components/decorators/volglijst",
    "components/decorators/filters-finance",
    "components/decorators/guide",
    // "components/decorators/kadastermap",
    "components/decorators/locations-selector",
    "components/decorators/newspanel",
    // "components/decorators/news-sentiment/news-sentiment",
    // "components/decorators/news-sentiment/news-sentiment-data",
    "components/decorators/dropdown-footer",
    "components/decorators/organisation-profile.js",
    "components/decorators/info-box",
    "components/decorators/order-extracts",
    "components/decorators/billing",
    "components/decorators/shareholder-information",
    "components/decorators/tooltip",
    "components/decorators/compute-price-checks",

    "components/handlers/company-index-updater",
    "components/handlers/tool-menu",
    "components/handlers/filters_finance",
    "components/handlers/filters_locations",
    // "components/handlers/analytics",
    "components/handlers/mysettings",
    "components/handlers/feedback",
    "components/handlers/iframe-subscription",
    "components/handlers/tablink-ajax",
    "components/handlers/quick-order",
    "components/handlers/download-dossier",
    "components/handlers/kyc-report/bulk-document-order",
    "components/handlers/kyc-report/bulk-compliance-order",
    "components/handlers/kyc-report/add-custom-note",
    "components/handlers/kyc-report/download-kyc-report",
    "components/handlers/kyc-report/start-kyc-report-order",
    'components/legacy-helpers',

    'lib/select2',

    'lib/jquery-ui',
    'moment',

    'lib/jquery.dataTables'

], function(decorator) {

    if ( companyInfo.lang === 'nl' ) {
        jQuery.extend(jQuery.fn.select2.defaults,{
            formatMatches: function (matches) {
                if (matches === 1) {
                    return "Een resultaat beschikbaar, druk op enter om het te selecteren.";
                }
                return matches + " resultaten beschikbaar, gebruik pijltjes toetsen om te selecteren."; },
            formatNoMatches: function () {
                return "Geen resultaten gevonden";
            },
            formatAjaxError: function (jqXHR, textStatus, errorThrown) {
                return "De resultaten konden niet worden geladen.";
            },
            formatInputTooShort: function (input, min) {
                var n = min - input.length;
                return "Gelieve " + n + " of meer karakters in te voeren";
            },
            formatInputTooLong: function (input, max) {
                var t=input.length-max;
                return "Gelieve "+t+" karakters te verwijderen";
            },
            formatSelectionTooBig: function (limit) {
                var t=limit==1?"kan":"kunnen",
                    n="Er "+t+" maar "+limit+" item";
                return limit!=1&&(n+="s"),n+=" worden geselecteerd",n;
            },
            formatLoadMore: function (pageNumber) { return "Meer resultaten laden…"; },
            formatSearching: function () { return "Zoeken…"; }
        });
    }

    decorator.run();

});

define("main", function(){});

